//Set data for confirm modal
import {notification} from "../helpers/notification";

$(function () {
    let fieldName = false;
    let modal = $('.js-confirmation-modal');
    let withOutAjax = false;
    let customEvent = null;
    let confirmSource = null;
    $(document).on('click', '.js-open-confirmation', function (e) {
        e.preventDefault();
        confirmSource = $(this);
        let url = $(this).data('url');
        let method = $(this).data('method');
        let status = $(this).data('status');
        let message = $(this).data('message');
        withOutAjax = $(this).data('without-ajax');
        fieldName = $(this).data('field');
        $('.js-confirmation-form').attr('action', url);
        $('.js-confirmation-message').text(message);
        $('.js-confirm-btn').attr('value', status).attr('data-method', method);
        customEvent = $(this).data('event-name') || null;
        $('#confirmation-modal').modal('show')
    })
//Set data for confirm modal

//Confirm data with ajax
    modal.on('click', '.js-confirm-btn', function (e) {
        e.preventDefault();
        let form = $('.js-confirmation-form');
        let data = null;
        if ($(this).attr('value')) {
            if (fieldName) {
                data = form.serialize() + '&'+fieldName+'=' + $(this).attr('value');
            } else {
                data = form.serialize() + '&status=' + $(this).attr('value');
            }
        } else {
            data = form.serialize();
        }
        if (withOutAjax) {
            //console.log(1)
            form.append(`<input type="hidden" name="_method" value="${$(this).data('method')}"/>`);
            if (fieldName) {
                form.append(`<input type="hidden" name="${fieldName}" value="${$(this).attr('value')}"/>`);
            } else {
                form.append(`<input type="hidden" name="status" value="${$(this).attr('value')}"/>`);
            }
            form.submit();
        } else {
            $.ajax({
                type: $(this).data('method'),
                url: form.attr('action'),
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                },
                data: data,
                success: function(response) {
                    if(window.location.pathname === '/admin/unsubscribe/patients') {
                        modal.modal('hide');
                        let unsubscribedUsersTable = $('#unsubscribed-users-table');
                        if (unsubscribedUsersTable.length) {
                            unsubscribedUsersTable.DataTable().ajax.reload();
                        }
                        notification(response.type, response.message);
                        return;
                    }
                    if(response.hasOwnProperty('checked')) {

                        if (response.action === 'doctor') {
                            let statusSwitch = $('#doctor-msb-status-switch-' + response.id);
                            $(statusSwitch).prop('checked', response.checked);
                            $(statusSwitch).data('status', response.checked ? 0 : 1);
                        }
                        if (response.action === 'company') {
                            let statusSwitch = $('#practice-msb-status-switch-' + response.id);
                            $(statusSwitch).prop('checked', response.checked);
                            $(statusSwitch).data('status', response.checked ? 0 : 1);
                            $('.js-msb-change-active').prop('checked', response.checked);
                            $('.js-msb-change-active').data('status',  response.checked ? 0 : 1);
                        }
                        if (response.action === 'msb-patient') {
                            let statusSwitch = $('#msb-switcher');
                            $(statusSwitch).prop('checked', response.checked);
                            $(statusSwitch).data('status', response.checked ? 0 : 1);
                        }
                        const activitySwitch = $(`.js-change-active[data-id="${response.id}"]`);
                        if (activitySwitch.length) {
                            const checked = response.checked === true
                                || response.checked === 1
                                || response.checked === '1';

                            activitySwitch
                                .prop('checked', checked)
                                .data('status', checked ? 0 : 1);
                        }
                        if (response.action === 'patient-cms') {
                            let statusSwitch = $('#cms-switcher');
                            $(statusSwitch).prop('checked', response.checked);
                            $(statusSwitch).data('status', response.checked ? 0 : 1);
                        }
                        if (response.action === 'doctor-cms') {
                            let statusSwitch = $('#doctor-cms-status-switch-' + response.id);
                            $(statusSwitch).prop('checked', response.checked);
                            $(statusSwitch).data('status', response.checked ? 0 : 1);
                        }
                    }
                    modal.modal('hide');
                    notification(response.type, response.message);
                    if (!!customEvent) {
                        const event = new CustomEvent(customEvent, { detail: {} });
                        window.dispatchEvent(event);
                        customEvent = null;
                    }

                    let reimbursementTable = $('#patient-reimbursement-table');
                    if (reimbursementTable.length) {
                        reimbursementTable.DataTable().ajax.reload();
                    }

                    if (!response.hasOwnProperty('checked') && confirmSource) {
                        const tableId = confirmSource.closest('table').attr('id');
                        if (tableId && $.fn.DataTable.isDataTable(`#${tableId}`)) {
                            $(`#${tableId}`).DataTable().ajax.reload(null, false);
                        }
                    }
                    confirmSource = null;

                },
                error: function (xhr) {
                    modal.modal('hide');
                    confirmSource = null;

                    let response = xhr.responseJSON;
                    if (!response && xhr.responseText) {
                        try {
                            response = JSON.parse(xhr.responseText);
                        } catch (e) {
                            response = null;
                        }
                    }

                    const isSessionExpired = xhr.status === 419 || response?.reload;
                    const message = response?.message || (isSessionExpired
                        ? 'Your session has expired. Please refresh the page and try again.'
                        : 'Something went wrong. Please try again.');

                    notification(response?.type || 'error', message);
                }
            })
        }
    })
//Confirm data with ajax end
})
